import styled from "@emotion/styled";
import { COLORS } from "../../header/header.styled";
import { fontStack, Title } from "../account/account-settings.styled";

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
`;

export const Icon = styled.img`
    height: 19px;
`;

export const StyledUl = styled.ul`
  ${fontStack}
  margin: 0;
  padding: 0 16px 16px 32px;
  line-height: 1.5;
  list-style: disc;
`;

export const StyledLi = styled.li`
  ${fontStack}
  color: ${COLORS.textMuted};
  padding-top: 8px;
  font-size: 14px;
  line-height: 1.5;
`;

export const StyledAnchor = styled.a`
  ${fontStack}
  color: ${COLORS.accent};
  text-decoration: underline;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const ControlsTitle = styled(Title)`
    font-size: 14px;
`;

export const ControlsStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

export const ColDescription = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    max-width: 320px;
`;

/**
 * We size the action buttons here rather than inline.
 * These are wrappers meant to be used with `as={OnboardBtn}` and `as={DeleteAccountButton}`.
 */
export const SmallPrimaryButton = styled.button`
    font-size: 15px;
    width: 117px;
    height: 44px;
`;

export const SmallDangerButton = styled.button`
    width: 117px;
    height: 44px;
`;
